export default {
  'document.meta.createdTime': 'Created At: {time}',
  'document.welcome.title': 'Welcome to Document Center',
  'document.welcome.desc': 'Please select a document from the left to view',
  'document.content.empty': 'No Content',
  'document.nav.prev': 'Previous',
  'document.nav.next': 'Next',
  'document.toc.title': 'On this page',
};
